// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "5005" ? "common" : chunkId) + "." + {"1022": "340c2b98a54f3c71","3042": "316f269ffd3db730","5005": "6acef6edcbf18878","8295": "9a4cb3da2f3321c8",}[chunkId] + ".chunk.js"
}